<template>
  <div>
    <!-- <pre>  {{lessonContent}}</pre> 
      {{lessonIndex}}
      {{TopicIndex}} -->
     <!-- <pre> {{topics}}</pre> -->
    <h3 class="course-heading">{{ topics.topic.name }}</h3>
    <div class="cstm-breadcrumb">
      <p class="bread-menus" @click="redirectBackToContent()">
        {{ lessonContent.name }}
      </p>
      <p class="bread-menus" @click="redirectBackToLesson()">
        {{ lessonContent.classLesson[lessonIndex].name }}
      </p>
      <p class="bread-menus">{{ topics.topic.name }}</p>
    </div>
    <!-- description about lesson -->
    <div class="desc-container">
      <p v-if="summary">
        {{ topics.topic.description | limitTo(200) }}
        <a v-if="topics.topic.description" @click="summary = false" >Read more</a>
      </p>
      <p v-else>
        {{ topics.topic.description }}
        <a v-if="topics.topic.description" @click="summary = true" >Read less</a>
      </p>
    </div>

    <vs-tabs class="cstm-card">
      <vs-tab label="Content" icon-pack="feather" icon="icon-align-justify">
        <vs-card v-if="topics.topic.topic_content.content">
          <p v-html="topics.topic.topic_content.content"></p>
        </vs-card>
      </vs-tab>

      <vs-tab label="Files" icon-pack="feather" icon="icon-file">
        <div>
          <div
            v-for="(eachFiles, index) in topics.topic.topic_files"
            :key="index"
            class="sm:w-1/2 md:w-1/3 lg:w-1/4 px-2"
          >
            <vs-card class="file-card">
              <div slot="header">
                <img
                  class="w-full file-image"
                  :src="eachFiles.file.file_path"
                  alt=""
                />
              </div>
              <h5 class="file-name">{{ eachFiles.file.file_name }}</h5>
              <p>{{ eachFiles.file.size }}</p>

               <vs-button color="success" 
                  class="float-right"
                  type="flat" @click="downloadImage(eachFiles.file)" icon-pack="feather" icon="icon-download"
                ></vs-button>
            </vs-card>
          </div>
        </div>
      </vs-tab>
    </vs-tabs>

    <div class="flex flex-wrap justify-between items-center">
      <div class="sm:w-auto w-full my-1">
        <vs-button
          v-if="TopicIndex == 0"
          class="w-full"
          icon-pack="feather"
          icon="icon-chevron-left"
          @click="redirectBackToLesson()"
          >          {{ lessonContent.classLesson[lessonIndex].name }}
        </vs-button>
        <vs-button
          v-else
          class="w-full"
          icon-pack="feather"
          icon="icon-chevron-left"
          @click="redirectNextTopic(-1)"
          >    
          Previous Topic
        </vs-button>
      </div>

      <div class="sm:w-auto w-full my-1" v-if="topics.topic.topic_complete_count === 0"> 
        <vs-button class="w-full" color="success"
          type="border"
        @click="saveComplete(topics.topic.id)"
          >Mark As Complete</vs-button
        >
      </div>

      <div class="sm:w-auto w-full my-1" v-else>
        
        <vs-button class="w-full" color="success" icon-pack="feather" icon="icon-check"
          >Completed</vs-button
        >
      </div>

      <div class="sm:w-auto w-full my-1">
        <vs-button
          v-if="
            lessonContent.classLesson[lessonIndex].lesson_topics
              .length -
              1 !=
            TopicIndex
          "
          class="w-full"
          icon-pack="feather"
          icon="icon-chevron-right"
          icon-after
          @click="redirectNextTopic(1)"
        >
        Next Topic

        </vs-button>

        <vs-button
          v-if="
            lessonContent.classLesson.length - 1 != lessonIndex &&
            lessonContent.classLesson[lessonIndex].lesson_topics
              .length -
              1 ==
              TopicIndex
          "
          class="w-full"
          icon-pack="feather"
          icon="icon-chevron-right"
          icon-after
          @click="redirectNextLesson()"
        >
        Next Lesson

        </vs-button>
      </div>

    </div>
  </div>
</template>

<script>
import {MarkCompleteMixin} from '../mixins/MarkCompleteMixin'
import axios from 'axios'


export default {
  props: {
    lessonContent: {
      type: Object,
      required: true,
      default: () => {}
    },
    lessonIndex: {type:Number,
      default:null},
    TopicIndex: {type:Number,
      default:null},
    platform_customer_id:{}
  },
  mixins:[MarkCompleteMixin],

  mounted () {},
    
  created () {
    this.topics = this.lessonContent.classLesson[
      this.lessonIndex
    ].lesson_topics[this.TopicIndex]
  },
  
  data () {
    return {
      topics: '',
      summary: false
    }
  },
  methods: {
    redirectBackToContent () {
      console.log('hi')
      this.$emit('backToContent')
    },
    redirectBackToLesson () {
      // console.log(this.lessonIndex)
      this.$emit('backToLesson', this.lessonIndex)
    },
    redirectNextLesson () {
      this.$emit('backToLesson', this.lessonIndex + 1)
    },
    redirectNextTopic (index) {
      this.$emit('backToTopic', this.lessonIndex, this.TopicIndex + index)
    },
    saveComplete (topic_id) {
      console.log(topic_id)
      const payload = {
        topic_id,
        type:3,
        platform_customer_id:this.platform_customer_id
      }


      const isMarkDone = this.markComplete(payload)
      if (isMarkDone) {
        console.log('hi')
        this.topics.topic.topic_complete_count = 1
      }
    },
    downloadImage (item) {
      console.log(item)
      axios({
        url: `${item.file_path}`,
        method: 'GET',
        responseType: 'blob'
      }).then((response) => {
        const fileUrl = window.URL.createObjectURL(new Blob([response.data]))
        const fileLink = document.createElement('a')
        fileLink.href = fileUrl

        fileLink.setAttribute('download', item.file_name)
        document.body.appendChild(fileLink)

        fileLink.click()
      }).catch(error => {
        console.log(error)
      }).finally(() => {
        console.log('hi')

      })

    }
  },
  filters: {
    limitTo (value) {
      if (!value) return ''
      return `${value.substring(0, 200)}...`
    }
  },

  watch: {
    lessonIndex () {
      this.topics = this.lessonContent.classLessons[
        this.lessonIndex
      ].lesson_topics[this.TopicIndex]
    },
    TopicIndex () {
      this.topics = this.lessonContent.classLessons[
        this.lessonIndex
      ].lesson_topics[this.TopicIndex]
    }
  }
}
</script>